export default function Newsletter() {
  return (
    <main className=" flex py-3 items-center justify-center bg-[#482607]">
      <div className="w-full max-w-2xl text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-2 text-balance">
          Subscribe to our Newsletter
        </h1>
        <p className="text-lg text-white/90 mb-2">
          Get updates right in your inbox
        </p>

        <form className="flex flex-col sm:flex-row max-w-xl mx-auto gap-0 sm:gap-0  w-full">
          <input
            type="email"
            placeholder="Enter your email"
            className="flex-1 px-4 py-2 border rounded-md sm:rounded-l-md sm:rounded-r-none text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-[#77C712] focus:outline-none"
            required
          />

          <button
            type="submit"
            className="px-6 py-2 bg-[#77C712] hover:font-semibold text-black transition-colors focus:ring-2 focus:ring-[#77C712] focus:outline-none rounded-md sm:rounded-r-md sm:rounded-l-none"
          >
            Subscribe
          </button>
        </form>
      </div>
    </main>
    // <section>
    //   <div
    //     className="container-fluid text-center text-white mt-5 pt-3 Subscribe-newsletter-container"
    //     style={{ backgroundColor: "482607" }}
    //   >
    //     <h6 className="Newsletter">Subscribe to our Newsletter</h6>
    //     <p className="get-updates">Get updates right in your inbox</p>
    //     <div className="container">
    //       <div className="row justify-content-center">
    //         <div className="col-md-6">
    //           <div className="input-group mb-3">
    //             <input
    //               type="text"
    //               className="form-control"
    //               placeholder="Enter your email"
    //               aria-label="Recipient's email"
    //               aria-describedby="basic-addon2"
    //               style={{ height: "36px" }}
    //             />
    //             <div className="input-group-append">
    //               <button
    //                 className="btn btn-primary green-subscribe-btn"
    //                 type="button"
    //                 style={{
    //                   height: "36px",
    //                   backgroundColor: "#77C712",
    //                   color: " #000000",
    //                   border: "none",
    //                   width: "146px",
    //                 }}
    //               >
    //                 Subscribe
    //               </button>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}
